<table mat-table [dataSource]="nachrichtenverlaufDataSource" class="mat-elevation-z8" multiTemplateDataRows>
  <ng-container matColumnDef="dokumentTyp">
    <th mat-header-cell *matHeaderCellDef>Dokument-Typ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.def.label }}
    </td>
  </ng-container>
  <!-- Erstelldatum Column -->
  <ng-container matColumnDef="createdOn">
    <th mat-header-cell *matHeaderCellDef>Erstelldatum</th>
    <td mat-cell *matCellDef="let element">
      {{ element.createdOn | amDateFormat: 'DD.MM.YYYY HH:mm:ss' }}
    </td>
  </ng-container>

  <!-- letzten Bearbeitung Column -->
  <ng-container matColumnDef="changedOn">
    <th mat-header-cell *matHeaderCellDef>Datum der letzten Bearbeitung</th>
    <td mat-cell *matCellDef="let element">
      {{ element.changedOn | amDateFormat: 'DD.MM.YYYY HH:mm:ss' }}
    </td>
  </ng-container>

  <!-- IconToggle Column -->
  <ng-container matColumnDef="iconToggle">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button>
        <mat-icon *ngIf="element !== expandedElement">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="element === expandedElement">keyboard_arrow_up</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
      <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
        <div class="element-description">
          <div class="element-detail-row" *ngIf="element.wert">
            <div class="element-detail-cell">
              <p>{{ getWertLabel(element.typeId) }}</p>
            </div>
            <div class="element-detail-cell">
              <p>
                {{ element.wert }}
              </p>
            </div>
          </div>
          <div class="element-detail-row" *ngIf="element.grund">
            <div class="element-detail-cell">
              <p>{{ getGrundLabel(element.typeId) }}</p>
            </div>
            <div class="element-detail-cell">
              <p>
                {{ element.grund }}
              </p>
            </div>
          </div>
          <div class="element-detail-row">
            <div class="element-detail-cell">
              <p>Status:</p>
            </div>
            <div class="element-detail-cell">
              <p>
                {{ getStatusLabel(element.typeId, element.status, element?.changedByBenutzer?.adm) }}
              </p>
            </div>
          </div>
          <div class="element-detail-row">
            <div class="element-detail-cell">
              <p>ID letzter Bearbeiter:</p>
            </div>
            <div class="element-detail-cell">
              <p>
                {{ element.changedBy }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="element-row"
    [ngClass]="{ 'invalid-row': row.status === 'H' }"
    [class.expanded-row]="expandedElement === row"
    (click)="toggleRowExpand(row)"
  ></tr>
  <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="expanded-detail-row"></tr>
</table>
